import { isRegisterCardFailResultCode } from '@entities/payment-methods'
import type { TranslationValues } from '@shared/config/i18n'
import { openAlertDialog } from '@shared/ui'
import { match } from 'ts-pattern'

type Translate = (key: string, values?: TranslationValues) => string

export const openRegisterCardErrorAlertDialog = (error: Error, t: Translate) => {
  if (error instanceof Error && isRegisterCardFailResultCode(error.cause)) {
    match(error.cause)
      .with('INVALID_CARD_TYPE', () => {
        openAlertDialog({ title: t('paymentMethods.creditCard.validation.invalidCardType') })
      })
      .with('INVALID_CARD_EXPIRATION', () => {
        openAlertDialog({ title: t('paymentMethods.creditCard.validation.invalidExpiration') })
      })
      .with('REJECT_CARD_COMPANY', () => {
        openAlertDialog({ title: t('paymentMethods.creditCard.validation.rejectedByCardCompany') })
      })
      .with('INVALID_CARD_IDENTITY', () => {
        openAlertDialog({ title: t('paymentMethods.creditCard.validation.identityFailed') })
      })
      .with('EXCEED_MAX_AUTH_COUNT', () => {
        openAlertDialog({ title: t('paymentMethods.creditCard.validation.identityFailed') })
      })
      .with('INVALID_CARD', () =>
        openAlertDialog({
          title: error.message,
        }),
      )
      .exhaustive()
  }
}
